export default "__VITE_ASSET__CZM3tgYr__"